export const chatsGermanLocalization = {
  components: {
    daySeparator: {
      today: 'Heute',
      yesterday: 'Gestern'
    },
    emptyChatState: {
      chatIsPrivate: 'Pssst… nur ihr zwei könnt hier lesen.',
      startWriting: 'Zeit für erste Worte!'
    },
    blockedChatState: {
      message: 'Du hast diese Person blockiert.'
    },
    messageMenu: {
      copy: 'Kopieren',
      edit: 'Bearbeiten',
      delete: 'Löschen',
      deleted: 'Nachricht gelöscht.',
      deletionFailed: 'Nachricht konnte nicht gelöscht werden.',
      deleteAlert: {
        title: 'Nachricht löschen?',
        content:
          'Deine Nachricht wird für alle Teilnehmenden dauerhaft gelöscht.',
        confirm: 'Löschen',
        cancel: 'Abbrechen'
      }
    },
    chatLimit: {
      message: 'Du hast die maximale Textlänge erreicht'
    },
    chatMessageImage: {
      copy: 'Kopieren'
    },
    chatMessageTextInput: {
      writePrivate: 'Privat schreiben...',
      notVerified: 'Du musst verifiziert sein um Chatten zu können.'
    }
  },
  screens: {
    chat: {
      accountDeleted: 'Gelöschtes Konto',
      menu: 'Optionen',
      reportViolation: 'Verstoß melden',
      blockUser: 'Person blockieren',
      unblockUser: 'Nicht mehr blockieren',
      archive: 'Archivieren',
      unarchive: 'Archivierung aufheben',
      message: {
        relatedToPost: 'Zum Funk vom {{date}}',
        relatedToComment: 'Zum Kommentar vom {{date}}',
        relatedToGroup: 'Zur Gruppe {{name}}',
        deleted:
          'Der Inhalt, auf den sich diese Unterhaltung bezieht, existiert nicht mehr.'
      }
    },
    chats: {
      title: 'Funkzentrale'
    }
  },
  'chat-archive': 'Archiv'
};

// Guarantees that both translations have the same structure
type Locales = typeof chatsGermanLocalization;

export const chatsEnglishLocalization: Locales = {
  components: {
    daySeparator: {
      today: 'Today',
      yesterday: 'Yesterday'
    },
    emptyChatState: {
      chatIsPrivate: 'Pssst... only you two can read here.',
      startWriting: 'Time for first words!'
    },
    blockedChatState: {
      message: 'You have blocked this person.'
    },
    messageMenu: {
      copy: 'Copy',
      edit: 'Edit',
      delete: 'Delete',
      deleted: 'Message deleted.',
      deletionFailed: 'Message could not be deleted.',
      deleteAlert: {
        title: 'Delete message?',
        content:
          'Your message will be deleted permanently for all participants.',
        confirm: 'Delete',
        cancel: 'Cancel'
      }
    },
    chatLimit: {
      message: 'You reached the maximum text length'
    },
    chatMessageImage: {
      copy: 'Copy'
    },
    chatMessageTextInput: {
      writePrivate: 'Write private...',
      notVerified: 'You need to be verified to chat.'
    }
  },
  screens: {
    chat: {
      accountDeleted: 'Deleted account',
      menu: 'Options',
      reportViolation: 'Report violation',
      blockUser: 'Block person',
      unblockUser: 'No more blocking',
      archive: 'Archive',
      unarchive: 'Unarchive',
      message: {
        relatedToPost: 'Regarding Funk from {{date}}',
        relatedToComment: 'Regarding comment from {{date}}',
        relatedToGroup: 'Regarding group {{name}}',
        deleted: 'The content this conversation refers to no longer exists.'
      }
    },
    chats: {
      title: 'Local Hub'
    }
  },
  'chat-archive': 'Archive'
};
